import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { Link, withRouter } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { providerPrefix } from "configs/routePrefix";
// import OrderService from "services/Seller/OrderService";
import DealsSvg from "assets/images/deals.svg"
import LeadsSvg from "assets/images/leads.svg"
import AppoinmentsSvg from "assets/images/appoinments.svg"

import "./styles.scss";
import { useSelector } from "react-redux";
const SellerSidebarContent = (props) => {
  const ref = useRef();
  const filter = useSelector(state=> state.adminFilter)

  const [orderNotifications, setOrderNotifications] = useState({});
  // const getOrderNotifications = async () => {
  //   const { data: notifications } =
  //     await new OrderService().getOrderNotifications();
  //   setOrderNotifications(notifications.data);
  // };
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName?.split('/')[2] === items[i].pathname?.split('/')[2]) {
          matchingMenuItem = items[i]
          break
        } else if(pathName === items[i].pathname){
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
    // getOrderNotifications();
  }, [props.location.pathname]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id='sidebar-menu'>
          <ul className='metismenu list-unstyled' id='side-menu'>
            <li className='menu-title'>{props.t("Menu")} </li>
            <li>
              <Link to={`${providerPrefix}/dashboard`}>
                <i className='bx bx-home'></i>
                <span>Dashboard</span>
              </Link>
            </li>
            <li>
              <Link to={`${providerPrefix}/Profile`}>
              <i className="fas fa-user"></i>
               <span>Profile</span>
              </Link>
            </li>
            <li className={!!filter?.developer_id ? 'mm-active' : ''}>
              <Link to={`${providerPrefix}/Admin-developer`} className={!!filter?.developer_id ? 'active' : ''}>
                <i className='fa fa-users-cog'></i>
                <span>Manage Developers</span>
              </Link>
            </li>
            <li>
              <Link to={`${providerPrefix}/appoinments`}>
                 <img src={AppoinmentsSvg} style={{marginRight:"12px"}} />
                <span>Manage Appointments</span>
              </Link>
            </li>
            <li>
              <Link to={`${providerPrefix}/deals`}>
                                <img src={DealsSvg} style={{ marginRight: "12px" }} />
                {/* <i className='bx bx-user'></i> */}
                {/* <img src={SalesRepIcon} style={{marginRight:"12px"}} /> */}
                <span>Manage Deals</span>
              </Link>
            </li>
            <li>
              <Link to={`${providerPrefix}/leads`}>
              <img src={LeadsSvg} style={{ marginRight: "12px" }} />
                {/* <img src={SalesRepIcon} style={{marginRight:"12px"}} /> */}
                <span>Manage Leads</span>
              </Link>
            </li>
            <li>
              <Link to={`${providerPrefix}/resale`}>
                <i className="fas fa-exchange-alt"></i>
                <span>Manage Resales</span>
              </Link>
            </li>
            <li>
              <Link to={`${providerPrefix}/seller`}>
                <i className="fas fa-users"></i>
                <span>Manage Seller</span>
              </Link> 
            </li>
            {/* <li>
              <Link to={`${providerPrefix}/promocodes`}>
                <i className='bx bxs-discount'></i>
                <span>discount</span>
              </Link>
            </li>
            <li>
              <Link to={`${providerPrefix}/ticket`}>
                <i className='bx bxs-receipt'></i>
                <span>Tickets</span>
              </Link>
            </li> */}
            {/* <li>
              <Link to='/#' className='has-arrow waves-effect'>
                <i className='bx bx-store'></i>
                <span>Product Management</span>
              </Link>
              <ul className='sub-menu' aria-expanded='false'>
                <li>
                  <Link to={`${providerPrefix}/product`}>
                    <span>Product</span>
                  </Link>
                  <Link to={`${providerPrefix}/delivery-area`}>
                    <span>Delivery Areas</span>
                  </Link>
                  <Link to={`${providerPrefix}/suggest-product`}>
                    <span>Suggest Product</span>
                  </Link>
                </li>
              </ul>
            </li> */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SellerSidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SellerSidebarContent));
